import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgDeleteFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M12.857 36.333c0 2.017 1.672 3.667 3.714 3.667H31.43c2.042 0 3.714-1.65 3.714-3.667v-21H12.857v21ZM37 8.833h-6.5L28.643 7h-9.286L17.5 8.833H11V12.5h26V8.833Z" />
        </svg>
    )
}
SvgDeleteFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgDeleteFill
